import React from 'react';
import { Button, Grid, IconButton, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

import swal from '@sweetalert/with-react';

import axiosInstance, { checkDeadline, EVENT_ID, getUserID, readFile, WEB_API } from '../constatns';
import { paperAction } from '../freepaper/FreePaperAction';
import Table from '../components/Table/Table';
import FreePaperSubmissionForm from '../freepaper/FreePaperSubmissionForm';
import FreePaperSubmissionConfirm from '../freepaper/FreePaperSubmissionConfirm';

class AbstractTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      role: sessionStorage.getItem('_in_role'),
      showMod: false,
      paperId: '',
      paperInfo: {},
      eposterFile: '',
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleMode = this.handleMode.bind(this);
    this.handleState = this.handleState.bind(this);
  }

  componentDidMount() {
    this.loadData();
    if (this.props.pid) {
      // console.log(this.props.showType);
      if (this.props.showType === 'review') {
        this.setState({ paperId: this.props.pid, showReview: true, paperInfo: this.props.pdata });
      } else {
        this.setState({ paperId: this.props.pid, showMod: true, paperInfo: this.props.pdata });
      }
    }
  }

  loadData() {
    axiosInstance.get(`${WEB_API}/paper/my?eventId=${EVENT_ID}&userId=${getUserID(true)}`).then((res) => {
      this.setState({ data: res.data });
    });
  }

  openNewWin(id, info, showType) {
    console.log(showType);
    if (this.props.isHome) {
      // this.props.handleTab(3, id, info, showType);
      // this.props.handleTab(2, id, info, showType);
      this.props.handleTab(4, id, info, showType);
    } else {
      if (showType === 'review') {
        this.setState({ paperInfo: info, paperId: id, showReview: true });
      } else {
        this.setState({ paperInfo: info, paperId: id, showMod: true });
      }
    }
  }

  handleState = (type, value) => {
    this.setState(() => ({ [type]: value }));
  };

  handleMode() {
    this.setState({ showReview: false, showMod: true });
  }

  handleClose() {
    this.setState({ showMod: false, showReview: false });
    this.loadData();
  }

  //업로드 버튼 클릭
  clickUpload(event, type) {
    event.preventDefault();
    document.getElementById(`${type}`).click();
  }

  //input 태그 -> 실제로 파일로 바꾸는 코드
  handleChangeFile = async (event, state) => {
    if (event.target.files[0]) {
      const targetFile = event.target.files[0];
      await readFile(targetFile)
        .then((file) => {
          this.setState({ eposterFile: targetFile }, () => {
            const _state = {
              isForeigner: state.isForeigner,
              file: this.state.eposterFile,
            };
            paperAction(_state, 'modify', state.id).then((result) => {
              swal('E-Poster file is uploaded successfully', {
                icon: 'success',
              });
              this.loadData();
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  deleteFile(id, file) {
    swal({
      text: 'Are you sure to delete file?',
      buttons: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance
          .post(`${WEB_API}/paper/img`, {
            evt: EVENT_ID,
            paperId: id,
            delKey: 'file',
            delPath: file.path,
          })
          .then((response) => {
            this.loadData();
            this.setState({ eposterFile: '' });
          })
          .catch((_err) => {
            console.error(_err);
          });
      }
    });
  }

  render() {
    const { data } = this.state;

    return (
      <Grid container>
        {!this.state.showMod && !this.state.showReview && (
          <Grid item xs={12}>
            {this.props.showNewBtn && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                disableElevation
                onClick={() => this.props.movePage('/paper/submission')}
                style={{ marginBottom: 10 }}
              >
                Make a new submission
              </Button>
            )}
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width="10%">No</TableCell>
                  <TableCell width="20%">Abstract No.</TableCell>
                  <TableCell width="40%">Abstract Title</TableCell>
                  <TableCell width="10%">Status</TableCell>
                  <TableCell width="20%">Review / Modify</TableCell>
                  <TableCell width="20%">Abstract Result</TableCell>
                  {/* <TableCell width="20%">File Upload</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data.length > 0 ? (
                  data.map((item, idx) => {
                    return (
                      <TableRow key={`abstract-data-${idx}`}>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell align="center">{item.paperRegNo}</TableCell>
                        <TableCell align="center">{item.abstractTitle}</TableCell>
                        <TableCell align="center">
                          {item.status ? (
                            item.status === 'Complete' ? (
                              <span style={{ color: 'blue' }}>{item.status}</span>
                            ) : (
                              <span style={{ color: 'red' }}>{item.status}</span>
                            )
                          ) : (
                            '-'
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                              variant="contained"
                              size="small"
                              color="primary"
                              disableElevation
                              onClick={() => {
                                this.openNewWin(item.id, item, 'review');
                              }}
                            >
                              Review
                            </Button>

                            <div style={{ width: '5px' }} />
                            <Button
                              variant="contained"
                              size="small"
                              color="primary"
                              disableElevation
                              onClick={() => {
                                // 마감 이후 수정 불가
                                if (!checkDeadline('paperDeadline')) {
                                  swal(
                                    // 'Abstract Submission is closed.',
                                    // 'PRS KOREA 2022 사무국으로 문의하여 주시기 바랍니다. Please request to PRS KOREA 2022 Secretariat.',
                                    // '',

                                    <div>
                                      <span style={{ fontSize: 27, fontWeight: 'bold' }}>Abstract Submission is closed.</span>
                                      <br />
                                      <br />
                                      <span>PRS KOREA 2022 사무국으로 문의하여 주시기 바랍니다.</span>
                                      <br />
                                      <span>Please request to PRS KOREA 2022 Secretariat.</span>
                                    </div>,
                                  );
                                } else {
                                  this.openNewWin(item.id, item, 'mod');
                                }
                              }}
                            >
                              Modify
                            </Button>

                            {/* {item.status && item.status === 'Complete' ? (
                              ''
                            ) : (
                              <>
                                <div style={{ width: '5px' }} />
                                <Button
                                  variant="contained"
                                  size="small"
                                  color="primary"
                                  disableElevation
                                  onClick={() => {
                                    this.openNewWin(item.id, item, 'mod');
                                  }}
                                >
                                  Modify
                                </Button>
                              </>
                            )} */}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          {/* Abstract Result */}
                          {item.result ? (item.result === 'None' ? '미채택' : `${item.result} 채택`) : '-'}
                        </TableCell>
                        {/* <TableCell align="center">
                          File Upload - E-Poster만, Oral 타입은 업로드 기능 없음
                          {item.result && item.result === 'E-Poster' ? (
                            <>
                              {item.file ? (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <p style={{ width: '10em' }}>
                                    <a href={item.file.path} style={{ wordBreak: 'break-all' }}>
                                      {item.file.name}
                                    </a>
                                  </p>
                                  <IconButton
                                    variant="contained"
                                    color={'primary'}
                                    size={'small'}
                                    onClick={(e) => this.deleteFile(item.id, item.file)}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </div>
                              ) : (
                                <>
                                  <input
                                    type="file"
                                    id={`eposter-file-picker-${idx}`}
                                    accept="application/vnd.ms-powerpoint,
                                application/vnd.openxmlformats-officedocument.presentationml.slideshow,
                                application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                    style={{ display: 'none' }}
                                    onChange={(e) => this.handleChangeFile(e, item)}
                                  />
                                  <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    disableElevation
                                    onClick={(e) => this.clickUpload(e, `eposter-file-picker-${idx}`)}
                                  >
                                    Upload
                                  </Button>
                                </>
                              )}
                            </>
                          ) : (
                            '-'
                          )}
                        </TableCell> */}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No submission
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Grid>
        )}
        {this.state.showMod && (
          <FreePaperSubmissionForm
            mode={'modify'}
            isMypage={true}
            abstractId={this.state.paperId}
            isPop={true}
            infoData={this.state.paperInfo}
            handleClose={this.handleClose}
            handleState={this.handleState}
          />
        )}
        {this.state.showReview && (
          <FreePaperSubmissionConfirm
            mode={'review'}
            isMypage={true}
            abstractId={this.state.paperId}
            data={this.state.paperInfo}
            handleMode={this.handleMode}
            handleClose={this.handleClose}
          />
        )}
      </Grid>
    );
  }
}

export default AbstractTable;
